
class ObjectUtils {
    public static copy(obj: any): any {
        return JSON.parse(JSON.stringify(obj));
    }
}

export default ObjectUtils;
